module.exports = __webpack_public_path__ + "static/media/camera-normal.738b08f4.svg";